import { useFieldHelper, FieldProps, FormattedDateField } from 'framework/ui/field';
import { Stack } from '@mui/material';
import { joinElements, DATE_FORMAT, SanitizedHtml, useAsyncValue } from 'framework/utils';
import { useApplicationSettings } from 'framework/uiTheme';

const CustomTemplateField = ({ source }: FieldProps) => {
  const { getValue } = useFieldHelper<any>({ source });
  const { useDefaultTextTransformer } = useApplicationSettings();
  const { mapAsyncTags = () => {}, mapTags = () => {} } = useDefaultTextTransformer?.() ?? {};
  const data = getValue();

  const displayedElements = data?.map((item: any, index: number) => {
    const syncData = mapTags(item.text);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const asyncData = useAsyncValue(async () => mapAsyncTags(syncData));

    return (
      <li key={`li-${item.text}-${item.index}`}>
        <Stack direction="row" spacing={1}>
          <FormattedDateField source={`${source}[${index}].createdAt`} format={DATE_FORMAT.FULL_DATE_TIME_AMPM} />
          <SanitizedHtml wrapperTag="span" html={asyncData || syncData} />
        </Stack>
      </li>
    );
  });

  return <ul style={{ color: 'var(--mui-palette-text-secondary)' }}>{joinElements(displayedElements || [], '')}</ul>;
};

export default CustomTemplateField;
